// Proje Finans Yönetimi tablosunun sütunları (eski tablonun 18 sütunu ve
// varsayılan görünürlüğü; kısa başlık başa alınıp sabitlendi).
// Metinler: projectFinance.columns.<key>.

export const PF_COLUMNS = {
  titleShort: { type: 'text', width: 230 },
  customer: { type: 'text', width: 200 },
  projectPhase: { type: 'select', width: 175 },
  projectDate: { type: 'date', width: 150 },
  projectDueDate: { type: 'date', width: 185 },
  firstInvoiceDate: { type: 'date', width: 170 },
  paymentFrequency: { type: 'text', width: 160 },
  projectDepartment: { type: 'text', width: 190 },
  projectCentersType: { type: 'text', width: 190 },
  coordinatorAcademician: { type: 'text', width: 230 },
  protocolNumber: { type: 'text', width: 180 },
  ethicsCommitteeDate: { type: 'date', width: 180 },
  ethicsCommitteeNumber: { type: 'text', width: 200 },
  ethicsCommitteePlace: { type: 'text', width: 200 },
  sbFirstApprovalDate: { type: 'date', width: 190 },
  sbFirstApprovalNumber: { type: 'text', width: 210 },
  sbProjectNumber: { type: 'text', width: 180 },
  titleLong: { type: 'text', width: 320 },
};

export const COLUMN_KEYS = Object.keys(PF_COLUMNS);
const HIDDEN = ['sbFirstApprovalDate', 'sbFirstApprovalNumber', 'sbProjectNumber', 'titleLong'];
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, !HIDDEN.includes(key)]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['titleShort'];
export const DATE_KEYS = COLUMN_KEYS.filter((key) => PF_COLUMNS[key].type === 'date');

// Aşama süzgeci (kayıtlı değerler; eski "Devam Ediyor" ve "Tamamlandı" da var)
export const PHASE_VALUES = ['Başlangıç', 'Aktif', 'Devam Ediyor', 'Pasif', 'Tamamlandı'];

// Hızlı süzgeç / kutucuk grupları
export const PHASE_GROUPS = ['active', 'passive', 'starting'];
export const ALL_PHASES = 'all';

export const phaseGroupOf = (phase) => {
  const value = String(phase || '').toLocaleLowerCase('tr-TR');
  if (value === 'aktif' || value === 'devam ediyor') return 'active';
  if (value === 'pasif' || value === 'tamamlandı') return 'passive';
  if (value === 'başlangıç') return 'starting';
  return 'other';
};

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
